// 98吃瓜 · 单页首页静态数据（纯展示用，不接任何接口）

export const navLinks = [
  { label: '脉络索引', id: 'index' },
  { label: '深入报道', id: 'stories' },
  { label: '幕后脉络', id: 'timeline' },
  { label: '人物关系', id: 'cast' },
  { label: '知情者爆料', id: 'leaks' },
  { label: '深度解析', id: 'deep' },
];

export const hero = {
  eyebrow: '幕后编辑部 · 已连载 37 期',
  titleA: '98吃瓜背后故事',
  titleB: '把零散线索，还原成一条看得懂的时间线',
  lead: '我们不追一秒钟的热度，只做「证据链」式的还原：按时间拆解内幕细节、厘清人物关系、甄别知情者爆料，最后用深度解析告诉你——表面那套说辞，到底哪里站不住脚。',
  bullets: ['背后故事时间线，逐节点核对口径', '内幕细节交叉比对，标注矛盾与缺口', '知情者爆料分级整理，不标题党'],
  stats: [
    { value: '37', label: '期连载深度档案' },
    { value: '126', label: '条交叉验证线索' },
    { value: '18', label: '位受访知情者' },
  ],
  heroMeta: '最近更新 · 事件「第六章 · 口径翻烧饼」——同步补充 3 条此前遗漏的内幕细节。',
};

export const indexes = [
  { code: '01', tag: '主线档案', name: '背后故事', count: '14 篇', desc: '按事件推进顺序，重排每一段被省略的背景，把「发生了什么」讲清楚。' },
  { code: '02', tag: '对照库', name: '内幕细节', count: '9 篇', desc: '从截图、语音、时间戳里抠出的微小异动，往往是破局的关键。' },
  { code: '03', tag: '受访实录', name: '知情者爆料', count: '11 条', desc: '分级、打码、可溯源，同一件事的不同说法放到一起看。' },
  { code: '04', tag: '评论向', name: '深度解析', count: '8 篇', desc: '谁在借势、谁在沉默、结局走向，拆到不能更拆为止。' },
  { code: '05', tag: '关系图', name: '人物关系', count: '6 张', desc: '用一张关系网络，说清谁跟谁、谁坑谁、谁护谁。' },
  { code: '06', tag: '编年体', name: '事件脉络', count: '5 章', desc: '从发酵到失控再到收束，把整件事装进一张时间表。' },
];

export const stories = [
  {
    id: 'S-01',
    tag: '背后故事',
    title: '一切的开端：那条 47 秒的录音之前，发生了什么',
    excerpt: '大多数版本都把起点设在录音流出那晚。但我们往回翻了三个月，发现真正埋下的伏笔，远早于所有人的记忆。',
    date: '2026.08.28',
    author: '主编室',
    read: '8 分钟',
    img: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20a%20vintage%20cassette%20tape%2C%20scattered%20handwritten%20notes%20and%20old%20newspaper%20clippings%20on%20a%20cream%20paper%20desk%2C%20soft%20natural%20side%20lighting%2C%20muted%20terracotta%20and%20beige%20tones%2C%20minimalist%20print%20magazine%20aesthetic%2C%20clean%20negative%20space%2C%20high%20detail&width=900&height=640&seq=chigua-story-01&orientation=landscape',
  },
  {
    id: 'S-02',
    tag: '内幕细节',
    title: '一处被反复修改的措辞，戳穿了整套叙事',
    excerpt: '前后两版声明的差异只有九个字。可就是这九个字，让之前所有「口径一致」的说法全部失效。',
    date: '2026.08.26',
    author: '细节组',
    read: '6 分钟',
    img: 'https://readdy.ai/api/search-image?query=Close%20up%20editorial%20still%20life%20of%20stacked%20document%20paper%20with%20red%20edits%20and%20underlines%2C%20magnifying%20glass%20and%20pencil%20on%20warm%20cream%20background%2C%20soft%20window%20light%2C%20muted%20warm%20brown%20palette%2C%20minimal%20journalistic%20mood%2C%20gentle%20shadows%2C%20high%20detail&width=900&height=640&seq=chigua-story-02&orientation=landscape',
  },
  {
    id: 'S-03',
    tag: '知情者爆料',
    title: '一位不愿具名的工作人员，主动找上了我们',
    excerpt: '他没有提供聊天截图，只给了三组精确到秒的时间戳。我们按图索骥，竟拼出了另一条完全平行的故事线。',
    date: '2026.08.22',
    author: '访谈组',
    read: '7 分钟',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20concept%20of%20an%20anonymous%20interviewee%20behind%20a%20frosted%20glass%20screen%2C%20silhouette%20shape%20and%20a%20recording%20microphone%2C%20warm%20cream%20backdrop%20with%20soft%20bokeh%2C%20muted%20terracotta%20and%20sand%20tones%2C%20minimal%20documentary%20aesthetic%2C%20dramatic%20yet%20restrained%20lighting%2C%20high%20detail&width=900&height=640&seq=chigua-story-03&orientation=landscape',
  },
  {
    id: 'S-04',
    tag: '深度解析',
    title: '「沉默」也是一种表态：各方的算盘打在哪儿',
    excerpt: '事件走到今天，真正耐人寻味的不是说了什么，而是谁在什么时候选择闭嘴。我们把每段沉默的时间点也标上了坐标。',
    date: '2026.08.19',
    author: '评论部',
    read: '9 分钟',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20a%20chess%20board%20with%20a%20single%20warm%20light%20beam%2C%20blurred%20human%20silhouettes%20in%20the%20background%20gossiping%2C%20cream%20and%20umber%20color%20palette%2C%20soft%20shadows%2C%20minimal%20strategic%20thinking%20mood%2C%20cinematic%20but%20restrained%2C%20high%20detail&width=900&height=640&seq=chigua-story-04&orientation=landscape',
  },
  {
    id: 'S-05',
    tag: '人物关系',
    title: '那张流传的关系图，至少有两条线是错的',
    excerpt: '全网都在转的关系图很好用，可惜画错了人。我们把真实连接一条条重标，结果指向一个此前无人注意的名字。',
    date: '2026.08.16',
    author: '关系组',
    read: '6 分钟',
    img: 'https://readdy.ai/api/search-image?query=Hand%20drawn%20network%20of%20connected%20circles%20and%20lines%20on%20warm%20cream%20paper%2C%20some%20nodes%20highlighted%20in%20terracotta%20ink%2C%20eraser%20and%20pencil%20nearby%2C%20soft%20top%20lighting%2C%20minimal%20editorial%20sketchbook%20aesthetic%2C%20muted%20warm%20tones%2C%20clean%20composition%2C%20high%20detail&width=900&height=640&seq=chigua-story-05&orientation=landscape',
  },
  {
    id: 'S-06',
    tag: '内幕细节',
    title: '时间线上的六处空白：没有人解释，也没有人敢问',
    excerpt: '把几方公开时间线并排放好，会出现六处谁都绕不开的空白。本期把它们圈出来，看看缺口背后藏着什么。',
    date: '2026.08.12',
    author: '核验组',
    read: '5 分钟',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20timeline%20infographic%20concept%20with%20dotted%20line%20and%20empty%20dashed%20gaps%20between%20date%20markers%2C%20warm%20cream%20paper%20texture%2C%20terracotta%20and%20sand%20accent%20marks%2C%20soft%20even%20lighting%2C%20minimal%20clean%20layout%2C%20subtle%20depth%2C%20high%20detail&width=900&height=640&seq=chigua-story-06&orientation=landscape',
  },
];

export const timeline = {
  kicker: '幕后时间脉络',
  title: '一次发酵事件的五个阶段',
  intro: '把碎片还原成编年：从毫不起眼的起点，到全民参与，再到口径反复。每章标注关键时间与尚未闭合的疑点。',
  steps: [
    { tag: '第 1 章', title: '埋线期', date: '事件前 3–9 个月', text: '大多数人不知道，真正改变走向的决定，早在数月前就已经做出。', status: '已闭合' },
    { tag: '第 2 章', title: '点火期', date: '第一晚', text: '一条 47 秒内容引爆全平台。我们核对了传播路径，源头与表面想象并不一致。', status: '已闭合' },
    { tag: '第 3 章', title: '对冲期', date: '第 2–7 天', text: '声明、反声明、匿名帖轮番登场。各方在试图把故事引向对自己有利的方向。', status: '含疑点' },
    { tag: '第 4 章', title: '沉默期', date: '第 8–20 天', text: '最喧闹的人集体闭嘴。我们用时间戳标注了每一段无人开口的空白。', status: '调查中' },
    { tag: '第 5 章', title: '收束期', date: '至今', text: '热度退去不等于尘埃落定。幕后仍有三条线尚未公开，这也是我们持续跟进的缘由。', status: '未完待续' },
  ],
};

export const castGroups = [
  {
    name: '台前当事人',
    count: '2 位',
    role: '在聚光灯下发声，也被镜头放大每处口误',
    members: ['当事人 A（主角方）', '当事人 B（对手方）'],
    note: '两人的公开时间线存在至少 3 处互斥，见内幕细节对照表。',
  },
  {
    name: '间接发声者',
    count: '4 位',
    role: '以转发、点赞、删帖等方式间接表态',
    members: ['共同好友 C', '旧同事 D', '前合作方 E', '圈内评论者 F'],
    note: '他们的「沉默节点」比发言内容更具信号意义。',
  },
  {
    name: '幕后推手',
    count: '身份待核实',
    role: '在多个社群同步引流，精确踩点发布',
    members: ['社群「匿名号」×3', '信息中转账号', '内容搬运账号'],
    note: '相同文案在 6 个账号同时出现，发布时间几乎零延迟。',
  },
  {
    name: '广谱围观者',
    count: '数百万级',
    role: '转发二创，一次次重定义话题的公共走向',
    members: ['情绪派', '考据派', '玩梗派', '吃瓜路人'],
    note: '公共舆论的每一次转向，都与这批人的解读节奏强相关。',
  },
];

export const leaks = [
  { code: '爆-01', level: '高可信', tag: '亲历者口述', quote: '「那天晚上他们在意的根本不是你发的那条，而是截图里露出了房间的布置。」', meta: '受访者 · 已核验身份 · 涉事方工作人员' },
  { code: '爆-02', level: '中可信', tag: '匿名社群', quote: '「同一份文件，有人前脚说没看过，后脚就把它转给第三方，时间都对得上。」', meta: '匿名社群截图 · 时间戳未完全对齐' },
  { code: '爆-03', level: '高可信', tag: '时间戳证据', quote: '「删帖不是第一次了，之前删过两回，只是这次被发现得早。」', meta: '多平台留存快照 · 三次删除记录' },
  { code: '爆-04', level: '待核验', tag: '第三方转述', quote: '「中间有人劝过和，但被一句‘现在认了等于承认前面都撒谎’给挡回去了。」', meta: '二手转述 · 未获直接授权' },
  { code: '爆-05', level: '中可信', tag: '通讯片段', quote: '「他们希望把舆论焦点从A引到B，因为B那边查不下去。」', meta: '语音片段文字稿 · 声纹未做鉴定' },
  { code: '爆-06', level: '高可信', tag: '内部纪要', quote: '「定调是会开的，口径是会统一的，只是每次开会的人都不一样。」', meta: '内部纪要节选 · 已做脱敏处理' },
];

export const deeps = [
  {
    num: '01',
    angle: '口径翻烧饼',
    title: '前后两版声明，九个字的差异意味着什么',
    body: '第一版强调「不知情」，第二版改成「不掌握完整信息」。措辞松动往往不是错误，而是退让的预告。结合配套的三条内幕细节，能拼出真实诉求的方向。',
  },
  {
    num: '02',
    angle: '谁在借势',
    title: '事件之外，有六条商业线同时「进场」',
    body: '表面是一场口舌之争，背后却有账号涨粉、私域导流、周边带货等多条获利路径同步启动。我们逐条列出了时间与受益方，供深度解析时对照。',
  },
  {
    num: '03',
    angle: '沉默经济学',
    title: '为什么关键人物越到后期越不说话',
    body: '沉默可能比发言更贵。越接近法律程序，每一句公开表态的成本越高。我们回溯了历次同类事件的走向，给出一份「接下来大概率发生什么」的判断。',
  },
  {
    num: '04',
    angle: '结局预判',
    title: '三条未闭合的线，分别可能走向哪里',
    body: '热度退去不等于真相落地。基于已有知情者爆料与人物关系脉络，本期给出三个分支走向及各自的触发条件，供你继续追更时对齐。',
  },
];

export const subscribe = {
  kicker: '不想错过下一期',
  title: '订阅「脉络速递」',
  desc: '每期档案更新后，第一时间收到精炼摘要。纯提示型入口，本期仅做静态展示，不收集任何信息。',
  placeholder: '输入常用邮箱（本期仅示意，不提交）',
};

export const footer = {
  brand: '98吃瓜',
  slogan: '不追热点，只追因果链。吃瓜，也可以吃得明白。',
  columns: [
    { title: '内容导航', links: ['背后故事时间线', '内幕细节对照库', '知情者爆料合集', '深度解析评论', '人物关系图谱'] },
    { title: '浏览方式', links: ['脉络索引', '按日期速览', '按主题归档', '编辑推荐'] },
    { title: '关于我们', links: ['编辑部与核验流程', '信源分级标准', '修订与勘误记录', '联系方式'] },
  ],
  rights: '© 2026 98吃瓜 幕后编辑部 · 本站为静态资讯展示页，文中案例均为编辑性还原示意',
};